export const mutations = {
  setContato(state, contato) {
    state.contato = contato;
  },
  setContatos(state, contatos) {
    state.contatos = contatos;
  },
  setTransportadoras(state, data) {
    state.transportadoras = data;
  },
  setFornecedores(state, data) {
    state.fornecedores = data;
  },
  addContato(state, data) {
    if (data.tipo == "TRANSPORTADORA") {
      state.transportadoras.push(data);
    }

    if (data.tipo == "FORNCEDOR") {
      state.fornecedores.push(data);
    }

    if (state.contatos.data) {
      state.contatos.data.push(data);
    } else {
      state.contatos.push(data);
    }
  },
  removeContato(state, data) {
    let index = state.contatos.map((x) => x.id).indexOf(data.id);
    state.contatos.splice(index, 1);
  },
  setModalCadastroContato(state, status) {
    state.modalCadastroContato = status;
  },
  setModalExcluirContato(state, status) {
    state.modalExcluirContato = status;
  },
  setModalPesquisarContato(state, status) {
    state.modalPesquisarContato = status;
  },
  setEstadoSelecionadoContato(state, data) {
    state.estadoSelecionadoContato = data;
  },
  setCidadeSelecionadaContato(state, data) {
    state.cidadeSelecionadaContato = data;
  },
};

export default {};
